<script>
    import Button, { Label } from '@smui/button';
    import Card from '@smui/card';
    import { Circle } from 'svelte-loading-spinners';
    import ContactFooter from "../common/contact/ContactFooter.svelte";
    import ErrorScreen from '../common/loading/ErrorScreen.svelte';
    import { downLoadSuccess, downloading, getDocuments } from "./download";

    export let captcha
    window.getDocuments = getDocuments
</script>
<svelte:head>
    <script src="https://www.google.com/recaptcha/api.js"></script>
</svelte:head>

{#if !($downLoadSuccess)}
    <ErrorScreen>
        Verzendinstructies
    </ErrorScreen>
{:else}
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <Card>
                    <div class="cng-card__primary cng-card__header-with-buttons">
                        <div class="mdc-typography--headline5">Verzendinstructies</div>
                        <div style="display: flex; align-items: center">
                            {#if $downloading}
                                <Circle size="30" color="#6200EE"/>
                            {/if}
                            <Button variant="raised"
                                    class="g-recaptcha ml-3"
                                    data-sitekey="{captcha.siteKey}"
                                    disabled="{$downloading}"
                                    data-callback='getDocuments'><Label>Download Documenten</Label></Button>

                        </div>
                    </div>
                    <div class="cng-card__divider"></div>
                    <div class="container-fluid" style="margin-top: 32px">
                        <div class="row mb-3">
                            <div class="col-xl col-12 cng-card__right-divider">
                                <div><img src="images/steps/step_1.png" class="center step-image"></div>
                                <div class="headline-center mdc-typography--headline5">Stap 1</div>
                                <div>
                                    <p>
                                        Download de documenten (in dit scherm rechtsboven). Print de documenten in zijn compleetheid uit (Excel vier werkbladen en pdf-overeenkomst).
                                    </p>
                                </div>
                            </div>
                            <div class="col-xl col-12 cng-card__right-divider">
                                <div><img src="images/steps/step_2.png" class="center step-image"></div>
                                <div class="headline-center mdc-typography--headline5">Stap 2</div>
                                <div>
                                    <p>
                                        Controleer of alle informatie naar waarheid is ingevuld en er geen gegevens ontbreken.
                                    </p>
                                </div>
                            </div>
                            <div class="col-xl col-12 cng-card__right-divider">
                                <div><img src="images/steps/step_3.png" class="center step-image"></div>
                                <div class="headline-center mdc-typography--headline5">Stap 3</div>
                                <div>
                                    <div class="mb-3">
                                        <p>
                                            Laat de documentatie ondertekenen door de wettelijk vertegenwoordiger(s) zoals
                                            ingeschreven in het KvK-handelsregister.
                                            <br>
                                            <br>
                                            Bij gezamenlijke bevoegdheid dient het formulier:
                                            "Wettelijk vertegenwoordiger & ondertekening" ondertekend te worden door een
                                            meerderheid van de wettelijke vertegenwoordigers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl col-12 cng-card__right-divider">
                                <div><img src="images/steps/step_4.png" class="center step-image"></div>
                                <div class="headline-center mdc-typography--headline5">Stap 4</div>
                                <div>
                                    <p>
                                        Zorg voor een kopie ID van een meerderheid van wettelijk vertegenwoordigers en van alle medewerkers die niet in loondienst zijn.
                                        <br>
                                        <br>
                                        <a href="https://www.google.com/url?q=https://www.rijksoverheid.nl/onderwerpen/identiteitsfraude/vraag-en-antwoord/veilige-kopie-identiteitsbewijs&sa=D&source=editors&ust=1620131452481000&usg=AOvVaw2is24V71W9XpvqEO5JCY1e">Klik hier</a>
                                        voor instructies voor het anoniem maken van de gegevens van de kopie-ID.
                                    </p>
                                </div>
                            </div>
                            <div class="col-xl col-12">
                                <div><img src="images/steps/step_5.png" class="center step-image"></div>
                                <div class="headline-center mdc-typography--headline5">Stap 5</div>
                                <div class="mb-3">
                                    <p>
                                        Verzend alle documentatie (4 tabbladen van het excelbestand) + offerte (pdf bestand) voorzien van originele handtekening(en) + 
                                        kopie ID(’s) van de wettelijke vertegenwoordiger(s) en de aan te melden gebruikers/beheerders naar:
                                        <br>
                                        <br>
                                        <b>
                                            We-ID
                                            <br>
                                            T.a.v. Beheermodule
                                            <br>
                                            Postbus 18
                                            <br>
                                            8200 AA Lelystad
                                        </b>
                                        <br>
                                        <br>
                                        Als u vragen heeft over de status van uw aanvraag voor We-ID Enterprise oplossing, neem dan gerust contact op met onze klantenservice. 
                                        U kunt hen bereiken via e-mail op <b>eh-support@we-id.nl</b> of telefonisch op <b>+31 (0)85-023 93 30</b>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ContactFooter/>
                </Card>
            </div>
        </div>
    </div>
{/if}
<style>
    .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
    }
    .headline-center {
        text-align: center;
    }
</style>